import { Icon, SectionHeading } from '@/components/atomic/atoms';
import { staticMediaStoreBaseURL } from '@/config/common';
import { captureGTMEventBrowseCategoriesClick } from '@/lib/gtm';
import { featuredCategories } from '@/services/homePage.service';

const RenderCategoryIcon = () =>
  featuredCategories.map(({ name, href, logoUrl }, index) => {
    const isSecondRowStart = index === 5;

    return (
      <div
        key={index}
        className={`bounce-animation ${isSecondRowStart ? 'col-start-2' : ''}`}
      >
        <Icon
          alt={name}
          anchorTagClass='relative'
          className='rounded-lg'
          containerClass='shadow-none filter hover:rounded-lg hover:shadow-2xl'
          href={href}
          imageHeight={228}
          imageWidth={200}
          onClick={() => captureGTMEventBrowseCategoriesClick({ name })}
          priority={true}
          title={name}
          titleClassName='font-semibold mt-2 mb-5 text-center'
          url={`${staticMediaStoreBaseURL}${logoUrl}`}
        />
      </div>
    );
  });

const FeaturedCategoriesWeb = () => (
  <div className='relative flex flex-col items-center mt-10 pb-10'>
    <SectionHeading
      {...{
        letterSpacing: '7.7px',
        title: 'Explore Services',
        titleClassName:
          'text-center tracking-widest uppercase text-neutral-800 font-basic font-normal mb-8',
        underline: false
      }}
    />
    <div className='grid grid-cols-5 gap-6 px-4 mt-10 justify-items-center'>
      <RenderCategoryIcon />
    </div>
  </div>
);

export default FeaturedCategoriesWeb;
